@let parentFormValue = parentForm();
@let selectedLanguageValue = selectedLanguage();

<div
  *transloco="let t; prefix: i18nPrefix()"
  class="flex flex-col gap-3"
  [formGroup]="parentFormValue"
>
  <mat-form-field class="w-full">
    <mat-label>{{ selectedLanguageValue === 'hu' ? t('TITLE_HU') : t('TITLE_EN') }}</mat-label>
    <input
      formControlName="title"
      matInput
      type="text"
      [name]="'title' | withLang: selectedLanguageValue"
    />
    <mat-error [control]="parentFormValue.get('title')!" />
  </mat-form-field>

  <mat-form-field class="w-full">
    <mat-label>{{
      selectedLanguageValue === 'hu' ? t('SHORT_DESCRIPTION_HU') : t('SHORT_DESCRIPTION_EN')
    }}</mat-label>
    <textarea
      formControlName="shortDescription"
      matInput
      rows="3"
      [name]="'short-description' | withLang: selectedLanguageValue"
    ></textarea>
    <mat-error [control]="parentFormValue.get('shortDescription')!" />
  </mat-form-field>

  <div class="relative">
    <pct-feature-rich-text-tip-tap-pct-ng-feature-rich-text-tip-tap
      nameAttribute="content"
      [formControl]="contentControl"
      [placeholder]="
        (selectedLanguageValue === 'hu' ? t('CONTENT_HU') : t('CONTENT_EN')) +
        ((contentControl | hasRequiredValidator) ? ' *' : '')
      "
      [required]="contentControl | hasRequiredValidator"
      [submitted]="submitted()"
    />
    @if (contentControl.disabled) {
      <div class="absolute top-0 left-0 opacity-40 w-full h-full bg-black"></div>
    }
  </div>
</div>
